"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeInsightWidgetFilterSettingsHandler = void 0;
var tslib_1 = require("tslib");
var layoutSelectors_1 = require("../../store/layout/layoutSelectors");
var effects_1 = require("redux-saga/effects");
var widgetValidations_1 = require("./validation/widgetValidations");
var layout_1 = require("../../store/layout");
var insight_1 = require("../../events/insight");
var filterOperations_1 = require("./common/filterOperations");
var filterValidation_1 = require("./validation/filterValidation");
var InsightWidgetFilterValidations = {
    dateDatasetValidator: filterValidation_1.validateDatasetForInsightWidgetDateFilter,
    attributeFilterValidator: filterValidation_1.validateAttributeFiltersToIgnore,
};
/**
 * Filter setting handler contains some of the more complex validations.
 *
 * If command specifies date dataset to use for date filter (meaning at the same time that date filter should be enabled),
 * then the date dataset validation occurs. This needs to perform complex query processing first to obtain all available
 * date datasets for the insight widget.
 *
 * If command specifies refs of display forms to ignore attribute filters by, then another validation occurs. This one
 * will ensure that the display form refs on the input represent valid, existing display forms. And then ensure that
 * those display forms are actually used in currently used attribute filters.
 */
function changeInsightWidgetFilterSettingsHandler(ctx, cmd) {
    var widgets, insightWidget, result, dateDataSet, ignoredFilters, ignoreDashboardFilters;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(layoutSelectors_1.selectWidgetsMap)];
            case 1:
                widgets = _a.sent();
                insightWidget = widgetValidations_1.validateExistingInsightWidget(widgets, cmd, ctx);
                return [4 /*yield*/, effects_1.call(filterOperations_1.processFilterOp, ctx, InsightWidgetFilterValidations, cmd, insightWidget)];
            case 2:
                result = _a.sent();
                dateDataSet = result.dateDataSet, ignoredFilters = result.ignoredFilters;
                ignoreDashboardFilters = ignoredFilters === null || ignoredFilters === void 0 ? void 0 : ignoredFilters.map(function (filter) {
                    var filterReference = {
                        type: "attributeFilterReference",
                        displayForm: filter.attributeFilter.displayForm,
                    };
                    return filterReference;
                });
                return [4 /*yield*/, effects_1.put(layout_1.layoutActions.replaceWidgetFilterSettings({
                        ref: insightWidget.ref,
                        dateDataSet: dateDataSet === null || dateDataSet === void 0 ? void 0 : dateDataSet.dataSet.ref,
                        ignoreDashboardFilters: ignoreDashboardFilters,
                        undo: {
                            cmd: cmd,
                        },
                    }))];
            case 3:
                _a.sent();
                return [2 /*return*/, insight_1.insightWidgetFilterSettingsChanged(ctx, insightWidget.ref, ignoredFilters !== null && ignoredFilters !== void 0 ? ignoredFilters : [], result.dateDataSet, cmd.correlationId)];
        }
    });
}
exports.changeInsightWidgetFilterSettingsHandler = changeInsightWidgetFilterSettingsHandler;
//# sourceMappingURL=changeInsightWidgetFilterSettingsHandler.js.map